


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Add to cart event
      onSubmitHandler(evt) {
        console.log("submit");
        evt.preventDefault();

        const text1 = this.form.querySelector('#silicone-text-1')?.value.trim();
        const text2 = this.form.querySelector('#silicone-text-2')?.value.trim();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      // Handle error
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton?.setAttribute('disabled', 'disabled');
          // Add the check here
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton?.removeAttribute('disabled');
          // And here
          if (this.submitButtonText) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
  
  

  // Remove checked from all radio elements so no variant is selected
 document.querySelectorAll('variant-selects input[type="radio"]').forEach(radio => radio.checked = false);
  
  // Note: Added '#' to the selectors assuming they are IDs. Adjusted the string formatting so querySelector works correctly.
  ['#silicone-1-discount', '#silicone-2-discount', '#silicone-3-discount', '#silicone-4-discount', '.product-form__buttons [name="add"]'].forEach((selector, index) => {
    const button = document.querySelector(selector);
    if (!button) return;

    button.addEventListener('click', function (evt) {
      evt.preventDefault();

      let radios = document.querySelectorAll('variant-selects input[type="radio"]');
      
      // ✅ CHANGES MADE HERE: Ab yeh alert sirf tab check karega jab product ke variants mojood honge
      if (radios.length > 0) {
        let noneChecked = Array.from(radios).every(radio => !radio.checked);

        if (noneChecked) {
          alert(window.translations.chooseSize);
          let variantSelects = document.querySelector('variant-selects');
          if (variantSelects) {
            variantSelects.scrollIntoView({ behavior: 'smooth', block: 'center' });
            variantSelects.classList.add("highlighted");
            setTimeout(() => { variantSelects.classList.remove("highlighted"); }, 1000);
          }
          return; 
        }
      }

      const productFormEl = document.querySelector('product-form');
      if (!productFormEl) return console.error('Product form not found.');

      const form = productFormEl.querySelector('form');
      const submitButton = productFormEl.querySelector('[type="submit"]');
      const spinner = productFormEl.querySelector('.loading__spinner');

      if (submitButton.getAttribute('aria-disabled') === 'true') return;

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      const qty = index < 4 ? index + 1 : 1; // Handled index to not set 5 for the regular add to cart button
      formData.set('quantity', qty);

      // ==========================================
      // --- FORCE MERGE CODE ---
      // Shopify only merges items if their properties are 100% identical.
      // We must delete any hidden properties (starting with '_') injected by apps.
      const keysToDelete = [];
      for (let key of formData.keys()) {
        if (key.startsWith('properties[_')) {
          keysToDelete.push(key);
        }
      }
      keysToDelete.forEach(key => formData.delete(key));
      // ==========================================

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      config.body = formData;


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            productFormEl.handleErrorMessage(response.description);

            const soldOutMessage = submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            productFormEl.error = true;
            return;
          } else if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          if (!productFormEl.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });
          productFormEl.error = false;

          const quickAddModal = productFormEl.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  CartPerformance.measure('add:paint-updated-sections', () => {
                    cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure('add:paint-updated-sections', () => {
              cart.renderContents(response);
            });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          if (!productFormEl.error) submitButton.removeAttribute('aria-disabled');
          spinner.classList.add('hidden');
        });
    });
  });
}